import React from "react";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";

import AddMenu from "./AddMenu.js";
import AddSubmenu from "./AddSubmenu.js";
import AddSubsubmenu from "./AddSubsubmenu.js";
import axios from "axios";

import NotificationAlert from "react-notification-alert";
import { useEffect } from "react";
import { VIEW_MENUS, DELETE_MENU } from "../../constants";

import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import {useHistory} from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";


import apiService from "../../variables/apiService"

const MenuList = () => {
  const [modalClassic, setModalClassic] = React.useState(false);
  const [value2, setValue2] = React.useState("");
  const [menuData, setMenuData] = React.useState([]);
  const [isEdit, setIsEdit] = React.useState(false);
  const [alert, setAlert] = React.useState(null);
  const notificationAlertRef = React.useRef(null);

  const [isLoading, setIsLoading] = React.useState(true);

  var localStorageUser = {};
  const navigate = useHistory();

  React.useEffect(() => {
   
    getMenusList();
  }, [modalClassic]);

  const getMenusList = () =>{
    var userObj = localStorage.getItem("user");
    var user = JSON.parse(userObj);
   
    localStorageUser = {
      userId: user.user_id,
    };

    apiService
      .postData(VIEW_MENUS, {
        id: localStorageUser.userId.toString(),
      })
      .then((res) => {setMenuData(res.data.menus);setIsLoading(false)})
      .catch((err) => {
        console.log("--err-", err)
        let options={}
          options = {
          place: "tr",
          message: "Unable to Fetch ",
          type: "warning",
  
          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
      });
  }

  const toggleModalClassic = () => {
    setModalClassic(!modalClassic);
  };

  const confirmdeleteUser = (id,item) =>{
    setAlert(<ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => deleteMenu(id,item)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You Want to Delete Menu ?
      </ReactBSAlert>
      );
  }
  const deleteMenu = async (dataid,item) => {
    let b = []
    b.push(dataid)
     item.submenu.map(dta=>{ b.push(dta.id);dta.subsubmenu.map(f=>b.push(f.id))})
 
    await apiService
      .postData(DELETE_MENU, { id:  b})
      .then((res) => {
        getMenusList(); 
        setAlert(null)})
      .catch((err) =>{
        console.log("--err-", err)
        let options={}
          options = {
          place: "tr",
          message: "Unable to Fetch ",
          type: "warning",
  
          autoDismiss: 2,
        };
        notificationAlertRef.current.notificationAlert(options);
      } );
  };

  const changePop = (alerpoop) => {
    notificationAlertRef.current.notificationAlert(alerpoop);
  };

  useEffect(() => {
    
    getMenusList();
    
  }, [isEdit]);

  return (
    <>
    {/* { localStorage.setItem("menus",JSON.stringify(menuData))} */}
   
     <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
      <div className="content pb-0 menu-list-icons">
        <Row>
         

          <Card>
            <CardBody >
            {alert}
              <NotificationAlert ref={notificationAlertRef} />
              <Row>
                <Col lg="12">
                  <h4 className="pull-right add-content" 
                      onClick={()=> navigate.push("/admin/user/createMenu")}>
                    <Button 
                      className="btn btn-icon btn-link-add btn-sm mr-2"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                    </Button>
                    Add Menu
                  </h4>
                </Col>
                <Col className="tableheightwf">
                  <Table responsive striped >
                    <tbody>
                      {menuData?.map((item, index) => {
                        
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>
                                <img src={item.icon} /> {item.displayname}
                              </td>
                              <td>
                                <ul>
                                  {item?.submenu?.map((data, i) => {
                                  
                                    return (
                                      <React.Fragment key={i}>
                                        <li>
                                          <b>{data.displayname}</b>
                                          <ol>
                                            {data?.subsubmenu?.map(
                                              (obj, index) => {
                                              console.log(obj.displayname);
                                                return (
                                                  <React.Fragment key={index}>
                                                    <li> {obj.displayname}</li>
                                                  </React.Fragment>
                                                );
                                              }
                                            )}
                                          </ol>
                                        </li>
                                      </React.Fragment>
                                    );
                                  })}
                                </ul>
                              </td>
                              <td>
                                <a to="" className="text-info mr-2">
                                  <i
                                    className="tim-icons icon-pencil"
                                    onClick={() => {
                                        navigate.push("/admin/user/updateMenu",{menus:[item]})
                                    
                                      //setIsEdit(true);
                                    }}
                                  ></i>
                                </a>{" "}
                                <a
                                  to=""
                                  value={item}
                                  //onClick={() => deleteMenu(item.id,item)}
                                  onClick={() =>confirmdeleteUser(item.id,item)}
                                  className="text-warning ml-2"
                                >
                                  <i className="tim-icons icon-trash-simple"></i>
                                </a>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Row>

        {/* Classic Modal */}
        <Modal
          isOpen={modalClassic}
          toggle={toggleModalClassic}
          className="roles-popup"
        >
          <div className="modal-header justify-content-center">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={toggleModalClassic}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h3 className="title title-up multicolortext">Add Menu Items</h3>
          </div>
          <ModalBody className="modelbody">
            <Row>
              <Col sm="12" lg="12" className="mb-4">
                <label className="label-headding">Menu Type </label>
                <br />
                <FormGroup check className="form-check-radio" inline>
                  <Label check>
                    <Input
                      id="exampleRadios3"
                      name="exampleRadio"
                      type="radio"
                      value="div1"
                      checked={value2 === "div1"}
                      onChange={(e) => setValue2(e.currentTarget.value)}
                    />
                    <span className="form-check-sign" />
                    Single layer Menu
                  </Label>
                </FormGroup>
                <FormGroup check className="form-check-radio" inline>
                  <Label check>
                    <Input
                      id="exampleRadios4"
                      name="exampleRadio"
                      type="radio"
                      value="div2"
                      checked={value2 === "div2"}
                      onChange={(e) => setValue2(e.currentTarget.value)}
                    />
                    <span className="form-check-sign" />
                    Two layer Menu
                  </Label>
                </FormGroup>
                <FormGroup check className="form-check-radio" inline>
                  <Label check>
                    <Input
                      id="exampleRadios5"
                      name="exampleRadio"
                      type="radio"
                      value="div3"
                      checked={value2 === "div3"}
                      onChange={(e) => setValue2(e.currentTarget.value)}
                    />
                    <span className="form-check-sign" />
                    Three layer Menu
                  </Label>
                </FormGroup>
              </Col>
              {value2 === "div1" && (
                <Col lg="12">
                  <Col className="div1">
                    <AddMenu btnSub={(val) => setModalClassic(val)} />
                  </Col>
                </Col>
              )}
              {value2 === "div2" && (
                <Col lg="12">
                  <Col className="div2">
                    <AddSubmenu btnSub={(val) => setModalClassic(val)} />
                  </Col>
                </Col>
              )}
              {value2 === "div3" && (
                <Col lg="12">
                  <Col className="div3">
                    <AddSubsubmenu btnSub={(val) => setModalClassic(val)} />
                  </Col>
                </Col>
              )}
            </Row>
          </ModalBody>
        </Modal>
        {/* End Classic Modal */}
      </div>
    </>
  );
};

export default MenuList;
